import { useLazyQuery, useMutation } from '@apollo/client';
import CustomizeLayoutQuiz from 'component/layout_quiz/layout_quiz';
import { User } from 'component/stylist_profile_header/types';
import { useAuth } from 'contexts/AuthContext';
import { GET_USER_BY_USERNAME } from 'graph_ql/users/queries';
import { useEffect, useState, useRef, useCallback } from 'react';
import _valuesIn from 'lodash/valuesIn';
import _isEqual from 'lodash/isEqual';
import _isEmpty from 'lodash/isEmpty';
import { useDispatch } from 'react-redux';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { CREATE_ANSWER } from '../../../graph_ql/getQuiz/mutation';
import { GET_QUESTION_DATA, GET_QUIZ_RESPONSE } from '../../../graph_ql/getQuiz/queries';
import { PATH } from '../../../routes/constant';
import { useStyles } from './styles';
import { getBudgetQuizId } from 'utils/utils';
import { setBudgetDefault } from 'redux/authentication/user_detail';
import { getAnsweredQuestions } from 'utils/convertListString';
import { useGetGender } from '../../../hooks/useGetGender';
import { EGENDER, quizContextType } from 'types/quiz';
import { EQuizOrder } from '../setup_quiz';
import { Spinner } from 'react-bootstrap';
import themes from 'styles/themes';
import Picker from 'component/ios_picker/iosPicker';
import { STRINGS } from '../../../constants/strings';

interface IQuestionData {
    value?: string;
    id?: string;
    title?: string;
}

interface Ianswer {
    title?: string;
    value?: string;
    id?: String;
    answerId?: string;
    userProperty?: string;
    answerUpdated?: string;
    action?: string;
    isSkipped?: string;
    required?: boolean;
    options?: IQuestionData[];
    questionDataSubjectTags?: string[];
    questionDataSubject?: string;
}

interface Iinput {
    questionId: String;
    questionSubject: String;
    contextType: String;
    contextId: String;
    value: String;
    valueType: String;
}

interface IProps {
    handleNext?: (value: Boolean, order?: number, gender?: EGENDER) => void;
}

const BudgetQuiz = (props: IProps) => {
    const { handleNext } = props;
    const { userName } = useParams<{ userName: string }>();
    const { currentUser } = useAuth();
    const gender = useGetGender(Boolean(userName));
    const [budgetQuizList, setBudgetQuizList] = useState<Ianswer[]>([]);
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const classes = useStyles();
    const currentSubjectTags = useRef<string[] | null>(null);
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
    const [currentActiveSlide, setCurrentActiveSlide] = useState(0);
    const [, setUser] = useState<User>();
    const [questionsLoading, setQuestionsLoading] = useState(false);
    const [userLoading, setUserLoading] = useState(false);
    const [valueGroups, setValueGroups] = useState('');
    const [selectedOption, setSelectedOption] = useState<any>({});
    const currentSlideRef: any = useRef(null);
    const [quizData, setQuizData] = useState<any>(null);
    const [pendingSaveApi, setPendingSaveApi] = useState(0);
    const [pendingApiLoading, setPendingApiLoading] = useState(false);
    const [inputToSave, setInputToSave] = useState<Iinput | null>(null);

    const [getQuestionData, { loading: questionDataLoading }] = useLazyQuery(GET_QUESTION_DATA, {
        onCompleted(data) {
            const list = budgetQuizList.map((item) => {
                if (_isEqual(item.questionDataSubjectTags, currentSubjectTags.current)) {
                    return {
                        ...item,
                        options: data.getQuestionData.data || [],
                    };
                }
                return { ...item };
            });
            setBudgetQuizList(list);
        },
    });

    useEffect(() => {
        if (budgetQuizList.length) {
            let firstBudgetQuiz = budgetQuizList[0];
            if (!firstBudgetQuiz.options?.length) {
                currentSubjectTags.current = firstBudgetQuiz?.questionDataSubjectTags || null;
                getQuestionData({
                    variables: {
                        input: {
                            subject: firstBudgetQuiz?.questionDataSubject,
                            tags: firstBudgetQuiz?.questionDataSubjectTags,
                            title: '',
                            paging: { page: 0, size: 50 },
                        },
                    },
                });
            }
        }
    }, [budgetQuizList, getQuestionData]);

    const [getQuizResponse] = useLazyQuery(GET_QUIZ_RESPONSE, {
        onCompleted(data) {
            const listAnswers = _valuesIn(data.getQuizResponse?.answers);
            const listQuestions = _valuesIn(data.getQuizResponse?.questions);
            setQuizData(data.getQuizResponse);
            dispatch(
                setBudgetDefault(getAnsweredQuestions(data.getQuizResponse?.answers, data.getQuizResponse?.questions)),
            );
            const list = listQuestions.map((item) => {
                const answeredBudget = listAnswers.find((i) => i.questionId === item.id);
                let options: IQuestionData[] = [];
                if (budgetQuizList.length) {
                    let existingBudget = budgetQuizList.find((i) => i.id === item.id);
                    if (!_isEmpty(existingBudget) && existingBudget?.options) {
                        options = existingBudget?.options;
                    }
                }
                if (answeredBudget) {
                    return {
                        ...item,
                        value: selectedOption?.questionId === item?.id ? selectedOption?.value : answeredBudget?.value,
                        options: options,
                        answerId: answeredBudget.id,
                    };
                }
                return { ...item, options: options };
            });
            if (
                selectedOption?.questionId === inputToSave?.questionId &&
                selectedOption?.value === inputToSave?.value
            ) {
                setValueGroups('');
                setSelectedOption({});
            }
            setBudgetQuizList(list);
            setQuestionsLoading(false);
        },
    });
    const [getUserByUserName] = useLazyQuery(GET_USER_BY_USERNAME, {
        onCompleted(data) {
            setUser(data.getUserByUserName);
            setQuestionsLoading(true);
            setUserLoading(false);
            getQuizResponse({
                variables: {
                    input: {
                        quizId: getBudgetQuizId(data?.getUserByUserName?.gender),
                        contextType: quizContextType,
                        contextId: getBudgetQuizId(data?.getUserByUserName?.gender),
                        userId: data?.getUserByUserName?.id,
                    },
                },
            });
        },
    });
    const handleNextClick = useCallback(() => {
        if (location.pathname === PATH.QUIZ_MANAGER) {
            if (handleNext) {
                handleNext(false, EQuizOrder.BUDGET, gender === EGENDER.MALE ? EGENDER.MALE : EGENDER.FEMALE);
            }
        } else {
            setPendingApiLoading(false);
        }
    }, [gender, handleNext, location.pathname]);

    useEffect(() => {
        if (pendingApiLoading && !pendingSaveApi) {
            handleNextClick();
        }
    }, [pendingApiLoading, pendingSaveApi, handleNextClick]);

    const processNextBudget = (slide, value, selectedOption) => {
        currentSlideRef.current = slide;
        const input = {
            contextId: getBudgetQuizId(gender),
            contextType: quizContextType,
            questionId: slide.id,
            questionSubject: slide.questionDataSubject,
            value: value,
            valueType: 'RANGE',
            questionDataIds: [selectedOption?.id],
            id: slide?.answerId,
        };
        if (input && input.questionId && input.value) {
            setPendingSaveApi((prevValue) => prevValue + 1);
            setInputToSave(input);
            createAnswer(input);
            setBudgetQuizList((prevList) =>
                prevList.map((item) => {
                    if (item.id === slide.id) {
                        return { ...item, value: input.value };
                    } else {
                        return item;
                    }
                }),
            );
            setTimeout(() => {
                if (swiperInstance) {
                    swiperInstance.allowSlideNext = true;
                    const itemIndex = budgetQuizList.findIndex((item) => item.id === slide.id);
                    if (itemIndex !== budgetQuizList.length - 1) {
                        try {
                            swiperInstance?.slideTo(itemIndex + 1);
                        } catch (error) {
                            console.debug(error);
                        }
                    } else if (itemIndex === budgetQuizList.length - 1) {
                        setPendingApiLoading(true);
                    }
                }
            }, 50);
        }
    };

    const createAnswer = (input: Iinput) => {
        const variables = {
            input,
        };
        answerMutation({ variables });
    };

    const [answerMutation] = useMutation(CREATE_ANSWER, {
        async onCompleted(response) {
            await getQuizResponse({
                variables: {
                    input: {
                        quizId: getBudgetQuizId(gender),
                        contextType: quizContextType,
                        contextId: getBudgetQuizId(gender),
                        userId: currentUser.uid,
                    },
                },
            });
            setPendingSaveApi((prevValue) => prevValue - 1);
        },
        onError(error) {
            console.error('Create Failed: ', error);
        },
    });

    useEffect(() => {
        if (currentUser && Boolean(!userName) && gender) {
            setQuestionsLoading(true);
            getQuizResponse({
                variables: {
                    input: {
                        quizId: getBudgetQuizId(gender),
                        contextType: quizContextType,
                        contextId: getBudgetQuizId(gender),
                        userId: currentUser.uid,
                    },
                },
            });
        }
    }, [currentUser, userName, gender, getQuizResponse, handleNext]);
    useEffect(() => {
        if (userName) {
            setUserLoading(true);
            getUserByUserName({
                variables: {
                    input: {
                        userName,
                    },
                },
            });
        }
    }, [userName, getUserByUserName]);

    const renderBudgetQuiz = (consumer, slide, index) => {
        return <CustomSlide slide={slide} index={index} />;
    };

    const handleChangeValue = (slide, name, value, selectedOption) => {
        if (value) {
            setValueGroups(value);
            setSelectedOption(selectedOption);
        }
    };

    const CustomSlide = ({ slide, index }) => {
        return (
            <div className={`${classes.styleContainer} style-container`}>
                <div className={classes.cardContainer}>
                    <div className={classes.title}>{slide.title}</div>
                    {slide.options.length ? (
                        <Picker
                            optionGroups={{
                                name: slide.options.map((option) => {
                                    return {
                                        label: option.localizationTitle,
                                        value: option.value,
                                        id: option.id,
                                        questionId: slide.id,
                                    };
                                }),
                            }}
                            valueGroups={{
                                name:
                                    valueGroups && slide.id === selectedOption?.questionId
                                        ? valueGroups
                                        : slide.options.find((option) => option.value === slide.value)?.value || '',
                            }}
                            onChange={(name, value, selectedOption) => {
                                return handleChangeValue(slide, name, value, selectedOption);
                            }}
                        />
                    ) : questionDataLoading ? (
                        <div className={`${classes.flexCenter} ${classes.pickerContainer} picker-container`}>
                            <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                        </div>
                    ) : (
                        <div className={`${classes.flexCenter} ${classes.pickerContainer} picker-container`}></div>
                    )}
                </div>
                {currentActiveSlide === index ? (
                    <button
                        type="submit"
                        key={index}
                        className={classes.button}
                        style={{
                            color: themes.palette.common.white,
                            // display: currentActiveSlide === index ? '' : 'none',
                            backgroundColor:
                                valueGroups && slide.id === selectedOption?.questionId
                                    ? themes.palette.primary.main
                                    : '#A3A3A3',
                        }}
                        onClick={() => {
                            if (valueGroups) {
                                processNextBudget(slide, valueGroups, selectedOption);
                            }
                        }}
                        disabled={!(valueGroups && slide.id === selectedOption?.questionId) || pendingApiLoading}
                    >
                        {location.pathname !== PATH.QUIZ_MANAGER ? STRINGS.UPDATE : STRINGS.SAVE}{' '}
                        {currentSlideRef?.current?.id === slide?.id && pendingApiLoading && (
                            <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                        )}
                    </button>
                ) : (
                    <div style={{ height: 44 }}></div>
                )}
            </div>
        );
    };

    const handleChangeSlide = (e) => {
        if (!userName) {
            if (swiperInstance) {
                if (location.pathname !== PATH.QUIZ_MANAGER) {
                    swiperInstance.allowSlideNext = true;
                } else if (budgetQuizList[e.realIndex]?.value) {
                    swiperInstance.allowSlideNext = true;
                } else {
                    swiperInstance.allowSlideNext = false;
                }
            }
        } else {
            if (swiperInstance) {
                swiperInstance.allowSlideNext = true;
            }
        }
        if (swiperInstance) {
            setCurrentActiveSlide(swiperInstance.activeIndex);
        }
        if (valueGroups) {
            setValueGroups('');
            setSelectedOption({});
        }
        let currentBudgetQuizOnSlide = budgetQuizList[e.realIndex];
        if (!currentBudgetQuizOnSlide?.options?.length) {
            currentSubjectTags.current = currentBudgetQuizOnSlide?.questionDataSubjectTags || null;
            getQuestionData({
                variables: {
                    input: {
                        subject: currentBudgetQuizOnSlide?.questionDataSubject,
                        tags: currentBudgetQuizOnSlide?.questionDataSubjectTags,
                        title: '',
                        paging: { page: 0, size: 50 },
                    },
                },
            });
        }
    };

    return (
        <CustomizeLayoutQuiz
            quizId={getBudgetQuizId(gender)}
            title={Boolean(!userName) ? quizData?.subTitle : ''}
            titlePage={quizData?.title}
            handleAnswer={() => {
                if (location.pathname === PATH.QUIZ_MANAGER) {
                    if (handleNext) {
                        handleNext(false, EQuizOrder.BUDGET, gender === EGENDER.MALE ? EGENDER.MALE : EGENDER.FEMALE);
                    }
                } else {
                    history.push(PATH.PROFILE);
                }
            }}
            isUpdate={location.pathname !== PATH.QUIZ_MANAGER}
            isDisplayContent={Boolean(!userName)}
            hideBottomNav={location.pathname === PATH.QUIZ_MANAGER}
            requiredQuestion={true}
            hideContinue={true}
            isHiddenAction={true}
            containerLoading={questionDataLoading || userLoading || questionsLoading}
        >
            <div className={classes.container}>
                <Swiper
                    direction="horizontal"
                    onSlideChange={handleChangeSlide}
                    onSwiper={setSwiperInstance}
                    slidesPerView={1.2}
                    centeredSlides={true}
                    spaceBetween={10}
                    className={classes.fitContent}
                    mousewheel
                >
                    {budgetQuizList.map((slide, index) => {
                        return (
                            <SwiperSlide key={index} className={classes.flexCenter}>
                                {renderBudgetQuiz(userName, slide, index)}
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
            </div>
        </CustomizeLayoutQuiz>
    );
};
export default BudgetQuiz;
